import { observable, action } from 'mobx';
import axios from 'axios';
import {
  login,
  logout,
  setPassword,
  userData,
  signup
} from '../../../services/api';
import { persist } from 'mobx-persist';
import { User } from '../../../models';
import { API_RESET_PASSWORD_URL, API_KEY } from '../../../constants';

class AuthStore {
  @observable isLoggedIn = false;
  @observable user = null;
  @observable tmpCognitoUser = null;
  @observable tmpEmail = null;

  @persist('object', User)
  @observable
  isImpersonator = null;

  constructor(uiState) {
    this.uiState = uiState;
  }

  login = async (mail, password) => {
    this.uiState.increasePendingRequest();
    const user = await login(mail, password);
    this.uiState.decreasePendingRequest();
    if (!user.error) {
      this.setUser(user);
      return this.user;
    } else if (user.newPasswordRequired) {
      this.setTmpCognitoUser(user.cognitoUser);
    }
    return user;
  };

  setLoginState = async () => {
    if (userData) {
      this.setUser(userData);
    }
  };

  logout = async () => {
    this.uiState.increasePendingRequest();
    await logout();
    this.uiState.decreasePendingRequest();
    this.setUser(null);
  };

  signup = async data => {
    this.uiState.increasePendingRequest();
    const response = await signup(data);
    this.uiState.decreasePendingRequest();
    return response;
  };

  setPassword = async password => {
    this.uiState.increasePendingRequest();
    const user = await setPassword(this.tmpCognitoUser, password);
    this.uiState.decreasePendingRequest();
    if (!user.error) {
      this.setUser(user);
      return this.user;
    }
    return user;
  };

  forgotPassword = async email => {
    axios({
      method: 'post',
      url: API_RESET_PASSWORD_URL,
      headers: { 'x-api-key': API_KEY, 'Content-Type': 'application/json' },
      data: JSON.stringify({ email })
    })
      .then(response => {
        console.log('reset_response', response);
        this.setTmpEmail(email);
      })
      .catch(error => {
        console.log('reset_error', error);
        this.setTmpEmail(email);
      });
  };

  @action
  setIsLoggedIn(value) {
    this.isLoggedIn = value;
  }

  @action
  setUser(rawData) {
    if (rawData) {
      this.user = new User(rawData);
      this.setIsLoggedIn(true);
    } else {
      this.user = null;
      this.setIsLoggedIn(false);
    }
  }
  @action
  setTmpCognitoUser(rawData) {
    this.tmpCognitoUser = rawData;
  }

  @action
  setTmpEmail(email) {
    this.tmpEmail = email;
  }

  @action
  setImpersonator(value) {
    this.isImpersonator = value;
  }

  @action
  unsetImpersonator() {
    this.isImpersonator = null;
  }
}

export default AuthStore;



// WEBPACK FOOTER //
// ./src/containers/login/store/AuthStore.js